import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import { toast } from "react-toastify";
import { updateUser } from '../../utils/actions/allactions';
import { validateAdmin } from "../../utils/helper";
import useDocumentTitle from "../../utils/useDocumentTitle";
import { useInstance } from "../../context/instance.context";
import Toggle from "react-toggle";

function EditAdminUser() {
    let navigate = useNavigate();
    useDocumentTitle('Edit Admin User')
    const token = localStorage.getItem('Token');
    const [adminValue, setAdminValue] = useState(JSON.parse(localStorage.getItem('adminUserToBeEdited')));

    const [error, setError] = useState("");
    const companyDomain = process.env.REACT_APP_SUPPORT_EMAIL?.split("@")[1] || '';
    

    useEffect(() => {
        validateAdmin(token, navigate);
        setAdminValue({ ...adminValue, email: adminValue.email.substring(0, adminValue.email.length - 12) })
    }, []);

    const handleEditAdminUser = async () => {
        setError("");

        const { firstName, lastName, email, accountStatus } = adminValue;

        if (!firstName || !lastName || !email || !accountStatus) {
            setError("Enter valid values for all the fields");
            return;
        }

        const lettersOnly = /^[A-Za-z]+$/;

        if (email.includes("@")) {
            setError("Please enter only the username part of the email (letters only, no domain).");
            return;
        }

        // if (!lettersOnly.test(email)) {
        //     setError("Email must contain only letters.");
        //     return;
        // }

        const domain = `${companyDomain}`;
        const finalEmail = `${email}@${domain}`;
        const finalData = { ...adminValue, email: finalEmail };

        try {
            const createdUser = await updateUser(token, finalData);

            if (createdUser.data.message === "Error creating a user") {
                toast.error('Error creating a user');
            } else {
                navigate('/admin/admin-users');
                toast.success("Admin user updated successfully");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong while updating user");
        }
    };
    const updateEmailSubscription = (value, fieldName) => {
        console.log("Value :", value, " Field Name :", fieldName);
        setAdminValue({ ...adminValue, [fieldName]: value });
    }



    return (
        <div className="admin-container">
            <Sidebar />
            <div className="right-container">
                <div className="center-heading">
                    <h1>  Edit Admin Users  </h1>
                    <div className="admin-user-container">
                        <div className="admin-user-header">
                            User Information
                        </div>
                        <div className="admin-user-body">
                            <div className="admin-user-name">
                                <input
                                    type="text"
                                    placeholder="First name *"
                                    value={adminValue.firstName}
                                    onChange={(e) => { setAdminValue({ ...adminValue, firstName: e.target.value }) }}
                                />
                                <input
                                    type="text"
                                    placeholder="Surname *"
                                    value={adminValue.lastName}
                                    onChange={(e) => { setAdminValue({ ...adminValue, lastName: e.target.value }) }}
                                />
                            </div>

                            <div className="admin-user-email">
                                <input
                                    type="text"
                                    placeholder="Primary email *"
                                    value={adminValue.email}
                                    onChange={(e) => { setAdminValue({ ...adminValue, email: e.target.value }) }}
                                />
                                <input className="disabled-email" placeholder={`@${companyDomain}`} disabled />
                            </div>

                            <div className="admin-user-email">
                                <p>This will be the email that the user signs in with</p>
                            </div>

                            <div className="admin-user-email">
                                <div className="admin-status-div">
                                    <label htmlFor="admin-status" >Admin Status</label>: &nbsp;
                                    <input
                                        name="admin-status"
                                        type="radio"
                                        value="Active"
                                        checked={adminValue.accountStatus === 'Active' ? true : ''}
                                        onChange={(e) => { setAdminValue({ ...adminValue, accountStatus: e.target.value }) }}
                                    />Active

                                    <input
                                        name="admin-status"
                                        type="radio"
                                        value="Inactive"
                                        checked={adminValue.accountStatus === 'Inactive' ? true : ''}
                                        onChange={(e) => { setAdminValue({ ...adminValue, accountStatus: e.target.value }) }}
                                    />Inactive
                                </div>


                            </div>
                            <div className="grid grid-cols-4 my-2  gap-4 admin-user-subscription">
                                <SubscriptionToggle
                                    label="Quote Created"
                                    value={adminValue.adminQuoteCreatedEmailSub}
                                    fieldName="adminQuoteCreatedEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="Issue Raised"
                                    value={adminValue.adminIssueRaisedEmailSub}
                                    fieldName="adminIssueRaisedEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="Review Target Cost"
                                    value={adminValue.adminReviewTargetCostEmailSub}
                                    fieldName="adminReviewTargetCostEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="Order Placed"
                                    value={adminValue.adminOrderPlacedEmailSub}
                                    fieldName="adminOrderPlacedEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="Stripe Event"
                                    value={adminValue.adminStripeEventEmailSub}
                                    fieldName="adminStripeEventEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="Feedback Received"
                                    value={adminValue.adminFeedbackReceivedEmailSub}
                                    fieldName="adminFeedbackReceivedEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="SO Report"
                                    value={adminValue.adminSoReportEmailSub}
                                    fieldName="adminSoReportEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="RFQ"
                                    value={adminValue.adminRfqEmailSub}
                                    fieldName="adminRfqEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="Offer"
                                    value={adminValue.adminOfferEmailSub}
                                    fieldName="adminOfferEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="Accept PO"
                                    value={adminValue.adminAcceptPoEmailSub}
                                    fieldName="adminAcceptPoEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="Bills Creation"
                                    value={adminValue.adminBillsCreationEmailSub}
                                    fieldName="adminBillsCreationEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />

                                <SubscriptionToggle
                                    label="ESD Change"
                                    value={adminValue.adminEsdChangeEmailSub}
                                    fieldName="adminEsdChangeEmailSub"
                                    updateEmailSubscription={updateEmailSubscription}
                                />
                            </div>
                        </div>
                    </div>
                    <button className="button-add" onClick={handleEditAdminUser}>Edit Admin User</button>

                    {
                        error ?
                            <div style={{ color: 'red', fontSize: '15px', textAlign: 'center', marginTop: '10px' }}>{error}</div>
                            : null
                    }
                </div>
            </div>
        </div>

    );
}

export default EditAdminUser;



const SubscriptionToggle = ({ label, value, fieldName, updateEmailSubscription }) => (
    <label
        style={{
            display: "flex",
            justifyContent: "space-between",
        }}
    >
        <span>{label} :&nbsp;</span>
        <div className="relative flex justify-center items-center">
            <Toggle
                defaultChecked={value}
                checked={value}
                icons={false}
                onChange={(e) => updateEmailSubscription(e.target.checked, fieldName)}
            />
            <span
                className={`absolute text-[10px] font-medium text-white ${value ? "left-2" : "right-2"
                    }`}
            >
                {value ? "On" : "Off"}
            </span>
        </div>
    </label>
);